function currencyFormSubmit(event) {
  event.target.form.submit();
}

document.querySelectorAll('.shopify-localization-form input').forEach(function(element) {
  element.addEventListener('change', currencyFormSubmit);
});

// Dynamic discount badge calculator
function calculateDiscountBadges() {
  const productItems = document.querySelectorAll('.product-item');

  productItems.forEach(item => {
    const label = item.querySelector('.product-label-dynamic, .product-label');
    if (!label) return;

    let soldOutLabel = label.querySelector('.sold-out-label');
    const isSoldOut = item.classList.contains('sold-out') || item.getAttribute('data-sold-out') === 'true' || !!soldOutLabel;

    if (isSoldOut) {
      const saleLabel = label.querySelector('.sale-label');
      if (saleLabel) {
        saleLabel.style.display = 'none';
      }
      if (!soldOutLabel) {
        soldOutLabel = document.createElement('strong');
        soldOutLabel.className = 'label sold-out-label';
        soldOutLabel.textContent = (window.inventory_text && window.inventory_text.soldoutlabel) ? window.inventory_text.soldoutlabel : 'Sold out';
        label.appendChild(soldOutLabel);
      }
      label.style.display = 'block';
      soldOutLabel.style.display = '';
      label.dataset.processed = 'true';
      return;
    }

    if (label.dataset.processed === 'true') return;

    // Get prices from the DOM
    const comparePrice = item.querySelector('.compare-price, .old-price');
    const currentPriceEl = item.querySelector('.special-price .vat__product:not(.compare-price), .price-regular .vat__product');

    if (comparePrice && currentPriceEl) {
      // Extract numeric values
      const comparePriceText = comparePrice.textContent.trim();
      const currentPriceText = currentPriceEl.textContent.trim();

      // Parse prices (remove currency symbols and convert to number)
      const compareValue = parseFloat(comparePriceText.replace(/[^0-9.,]/g, '').replace(',', '.'));
      const currentValue = parseFloat(currentPriceText.replace(/[^0-9.,]/g, '').replace(',', '.'));

      if (compareValue > currentValue && compareValue > 0) {
        // Calculate discount percentage
        const discount = Math.round(((compareValue - currentValue) / compareValue) * 100);

        if (discount > 0) {
          const labelText = label.querySelector('.sale-label');
          if (labelText) {
            labelText.textContent = `-${discount}%`;
            label.style.display = 'block';
            label.dataset.processed = 'true';
          }
        }
      }
    }
  });
}

// Observe for new products (infinite scroll, AJAX loading)
function observeProductChanges() {
  const observer = new MutationObserver((mutations) => {
    let shouldRecalculate = false;
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1 && (node.classList?.contains('product-item') || node.querySelector?.('.product-item'))) {
          shouldRecalculate = true;
        }
      });
    });
    if (shouldRecalculate) {
      setTimeout(calculateDiscountBadges, 100);
    }
  });
  
  const collectionContainer = document.querySelector('.collection-content, .productGrid, .products-grid, main');
  if (collectionContainer) {
    observer.observe(collectionContainer, {
      childList: true,
      subtree: true
    });
  }
}

// Initialize on page load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    calculateDiscountBadges();
    observeProductChanges();
  });
} else {
  calculateDiscountBadges();
  observeProductChanges();
}

// Recalculate on scroll (for lazy-loaded content)
let scrollTimeout;
window.addEventListener('scroll', function() {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(calculateDiscountBadges, 200);
}, { passive: true });

function closeCab(event) {
  document.getElementById("custom-announcement-bar").style.display = "none";
}

// Ensure clean product URLs inside product recommendations (strip tracking/query params)
(function() {
  // Toggle debug logs in console
  if (typeof window.PL_DEBUG === 'undefined') {
    window.PL_DEBUG = true;
  }

  function cleanRecommendationLinks(root) {
    try {
      var container = (root && root.querySelector) ? root : document;
      var links = container.querySelectorAll('.product-recommendations a[href*="/products/"]');
      var changedCount = 0;
      var total = 0;
      links.forEach(function(link) {
        total += 1;
        try {
          var url = new URL(link.href, window.location.origin);
          // Keep only pathname to remove any query parameters like pr_prod_strat, pr_rec_id, etc.
          var current = link.getAttribute('href');
          var clean = url.pathname;
          if (current !== clean) {
            link.setAttribute('href', clean);
            changedCount += 1;
          }
        } catch (e) { /* ignore malformed urls */ }
      });
      if (window.PL_DEBUG) {
        console.debug('[PL] cleanRecommendationLinks()', { total: total, changed: changedCount, root: container });
      }
    } catch (e) { /* noop */ }
  }

  // Run on initial DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      if (window.PL_DEBUG) { console.debug('[PL] DOMContentLoaded → sanitize now'); }
      cleanRecommendationLinks(document);
    });
  } else {
    if (window.PL_DEBUG) { console.debug('[PL] DOM already parsed → sanitize now'); }
    cleanRecommendationLinks(document);
  }

  // Also run after the recommendations Ajax block loads
  if (window.jQuery) {
    jQuery(document).ajaxComplete(function(_evt, _xhr, settings) {
      try {
        if (settings && settings.url && settings.url.indexOf('/recommendations/products') !== -1) {
          // Recommendations content just (re)loaded
          var container = document.getElementById('product-recommendations');
          if (window.PL_DEBUG) { console.debug('[PL] ajaxComplete(recommendations) → sanitize'); }
          cleanRecommendationLinks(container || document);
        }
      } catch (e) { /* noop */ }
    });
  }

  // Observe DOM mutations within recommendations to re-sanitize links if any script re-injects params
  var observeTargets = [
    document.getElementById('product-recommendations'),
    document.getElementById('shopify-section-product-recommendations')
  ].filter(Boolean);

  observeTargets.forEach(function(target) {
    try {
      var observer = new MutationObserver(function() {
        if (window.PL_DEBUG) { console.debug('[PL] MutationObserver(recommendations) → sanitize'); }
        cleanRecommendationLinks(target);
      });
      observer.observe(target, { childList: true, subtree: true });
    } catch (e) { /* noop */ }
  });

  // As a final safeguard, strip params on click before navigation
  document.addEventListener('click', function(evt) {
    var anchor = evt.target.closest && evt.target.closest('.product-recommendations a[href*="/products/"]');
    if (anchor) {
      try {
        var url = new URL(anchor.href, window.location.origin);
        var cleanPath = url.pathname;
        // If href contains params, rewrite to clean path and let the click proceed
        if (anchor.getAttribute('href') !== cleanPath) {
          anchor.setAttribute('href', cleanPath);
        }
        if (window.PL_DEBUG) { console.debug('[PL] click(sanitize before nav)', { href: anchor.getAttribute('href') }); }
      } catch (e) { /* noop */ }
    }
  }, true);

  // Delay-run on product pages: sanitize links 3s after load for late-running scripts
  try {
    var isProductPage = (document.body && document.body.classList.contains('template-product')) || (window.location.pathname.indexOf('/products/') === 0);
    if (isProductPage) {
      setTimeout(function() {
        var container = document.getElementById('product-recommendations');
        if (window.PL_DEBUG) { console.debug('[PL] 3s delayed sanitize on product page'); }
        cleanRecommendationLinks(container || document);
      }, 3000);
    }
  } catch (e) { /* noop */ }

  // Expose a manual test hook
  try {
    window.PL_sanitizeRecommendations = function() {
      var container = document.getElementById('product-recommendations');
      if (window.PL_DEBUG) { console.debug('[PL] manual sanitize'); }
      cleanRecommendationLinks(container || document);
    };
  } catch (e) { /* noop */ }
})();
